import type { Staff } from "@/lib/authv2/store";
import { ACTION } from "@/lib/auth/actions";
import { hasPermission } from "@/lib/authv2/permissions";

export function canWriteExpenses(staff: Staff | null): boolean {
  if (!staff) return false;
  return hasPermission(ACTION.ExpenseWrite);
}

/**
 * Sổ chi phí là tiền: ĐỌC cũng qua cổng từ 13/09/2026 (QĐ 0132 §8 câu 4a) —
 * trước đó mọi người đăng nhập đều đọc được sổ của cơ sở mình, chỉ menu bị ẩn.
 * Máy chủ gác `GET /monthly-expenses` bằng `expense.read`; vé chưa đăng nhập
 * lại sau `casdoor-policy-sync` thì chưa có quyền — trang phải nói rõ thay vì
 * hiện bảng rỗng.
 */
export function canReadExpenses(staff: Staff | null): boolean {
  if (!staff) return false;
  return hasPermission(ACTION.ExpenseRead);
}
